import { render, staticRenderFns } from "./ApmsBasicLaborTeam.vue?vue&type=template&id=5768439c&scoped=true&"
import script from "./ApmsBasicLaborTeam.vue?vue&type=script&lang=js&"
export * from "./ApmsBasicLaborTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5768439c",
  null
  
)

export default component.exports